module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	
	fox.registerWidget('Promo_Home', {
		configure: function (options) {
			this.registerOptions('', {
				headerHeight: 109,
				template: 'promo_home',
				'hooks.onStartRendering': function () {
					var landingDesign = fox.cookie.get('landingDesign');
					if (landingDesign) {
						this.setTemplateOptions({urban: 1});
					}
				},
				widgets: {
					saveEmailApi: {
						widget: 'Api',
						method: 'Promo.saveEmail'
					},
					regForm: {
						widget: 'Promo_Registration',
						group: 'lastBlock',
						active: true,
						autoRender: true,
						container: '#registration-block',
						template: 'promo_reg_form'
					},
				},
				


				handleDom: {
					playGirl: {
						target: '.video, .play-button',
						event: 'click',
						callback: function(elt) {
							var $parent = $(elt).parent(); 
							if($parent.hasClass('play')){
								$parent.removeClass('play').addClass('pause');
								$parent.find('.video')[0].pause();
							} else {
								$parent.removeClass('pause').addClass('play');
								$parent.find('.video')[0].play();
							}
						}
					},

					videoEnded: {
						target: '.video',
						event: 'ended',
						callback: function(elt){
							var $parent = $(elt).parent();
							$parent.removeClass('play').addClass('pause');
						}
					},

					toRegistration: {
						target: '.continue',
						event: 'click',
						callback: function() {
							this.scrollSection('registration');
						}
					},

					sliderClick: {
						target: '.slider-pager .page',
						event: 'click',
						callback: 'switchSlide'
					},

					hideError: {
						target: '.pre-form .email input',
						event: 'focus',
						callback: function() {
							$('.pre-form .email').removeClass('error').removeClass('phperror');
						}
					},

					submitEmail: {
						target: '.submit-email',
						event: 'click',
						callback: fox.bind(function (elt) {
							var email = $('input[name="pre-form-email"]').val();
							var regForm = this.wom1('#regForm');
							var validator = new fox.Validator();
							validator.addRule('email', {validator: 'regexp', options: {type: 'email'}});
							
							if (!validator.validate('email', email)) {
								$('.pre-form .email').addClass('error');
								return false;
							}
							var api = this.rwom1('#saveEmailApi');
							this.waitEvent(api, 'ready', function () {
								email = $('input[name="pre-form-email"]').val();
								$('#reg-form [name="email"]')[0].value = email;
								regForm.checkEmail();
								this.scrollSection('registration');
								var ga = fox.wom.selectFirst('@root #googleAnalytics');
								ga.trackEvent({'eventLabel': 'Promo e-mail submit', 'eventCategory': 'NewPromoPage', 'eventAction': 'saveEmail'});
							});
							this.waitEvent(api, 'failure', function () {
								$('.pre-form .email').addClass('error phperror');
							});
							api.send({email: email});
						}, this)
					}
				},

				handleWom:{
					addedToDom: {
						widget: '@this',
						event: 'addedToDom',
						callback: fox.bind(function () {
							var currentLang = this.wom1('@parent @parent #header #langSwitcher').currentLang;
							this.createGalleries();
							this.orientationChange();
							this.targetFromNavigator();
						}, this),
						'params.prefix': 'customHandlers'
					},
					scrollSection: {
						widget: fox.Navigator,
						event: 'modified_0',
						callback: 'targetFromNavigator',
						'params.prefix': 'scrollSection'
					},
					switchLang: {
						widget: '@parent @parent #header #langSwitcher',
						event: 'langSwitched',
						callback: 'switchLangVideo',
						'params.prefix': 'promoswitchlang'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);
			this.switchLangVideo();
		},

		deactivate: function () {
			var regForm = this.wom1('#regForm');

			if (regForm) {
				this.switchEmbeddedWidget('regForm');
			}

			if (this.isTouchDevice()) {
				window.removeEventListener("orientationchange");
			}

			this.callParent('deactivate', arguments);
		},

		createGalleries: function () {
			if (!$('.slick-initialized')[0]) {
				this.createTouchFeaturesGallery();
			} else {
				$('#slider-features').slick('setPosition');
			}
			
		},

		createTouchFeaturesGallery: function () {
			var sliders = ['slider-features1', 'slider-features2', 'slider-features3'];
			fox.each(sliders, function(slide){
				$('#' + slide).slick({
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: true,
					adaptiveHeight: true,
					speed: 500,
					fade: true,
					responsive: [
						{
							breakpoint: 320,
							settings: {
								dots: true,
								dotsClass: 'slick-dots',
								centerMode: false
							}
						},
						{
							breakpoint: 768,
							settings: {
								dots: false,
								arrows: false
							}
						},
						{
							breakpoint: 1200,
							settings: {
								arrows: true
							}
						}
					]
				});

				$('#' + slide).on('afterChange', function(event, slick, currentSlide, nextSlide){
					$(this).parent().find('.page').each(function(i, elt){
						$(elt).removeClass('active');
					});
					$(this).parent().find('[data-slide='+ currentSlide +']').addClass('active');
				});
			}, this);
			
		},

		switchSlide: function(elt) {
			var slideNum = $(elt).attr('data-slide');
			slideNum = (!!slideNum) ? slideNum : 1;
			$(elt).parent().next().slick('slickGoTo', slideNum);
		},

		isTouchDevice: function () {
			var DocumentTouch;
			return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		},

		orientationChange: function() {
			window.addEventListener("orientationchange", fox.bind(function() {
				window.setTimeout(fox.bind(function () {
					this.createGalleries();
				}, this), 500);
			}, this), false);
		},

		targetFromNavigator: function() {
			var target = fox.Navigator.get(0);
			this.scrollSection(target);
		},

		scrollSection: function(target) {
			if (!target) {
				//$('body, html').animate({scrollTop: 0}, 500);
				return;
			}
			var dopOffsetTop = $('.promo-header.sticky').height();
			var $target = $('#'+ target);

			if (dopOffsetTop) {
				dopOffsetTop = isNaN(parseInt(dopOffsetTop)) ? $(dopOffsetTop).outerHeight(true) : parseInt(dopOffsetTop);
			}

			if ($target) {
				$('body, html').animate({
					scrollTop: $target.offset().top - dopOffsetTop
				}, 500);
			}
		},

		switchLangVideo: function(){
			var currentLang = this.rwom1('@parent @parent #header #langSwitcher').currentLang;
			this.setTemplateOptions({lang: currentLang});
		}
	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/home.js
// module id = 670
// module chunks = 2